{
  "version": 1,
  "asset_id": "8c0daa72-906b-46e7-93b0-ae06962a9463",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8c0daa72-906b-46e7-93b0-ae06962a9463/hiatal-type-1-v3-1254.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8c0daa72-906b-46e7-93b0-ae06962a9463/hiatal-type-1-v3-1254.jpg",
  "original_filename": "hiatal-type-1-v3-1254.jpg",
  "size": 208877,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:09:16Z"
}
